export default "__VITE_ASSET__DB$qR_kM__"